export const unfoldDepth = () => () => {
    return async function (nodes, depth) {
        await this.execute(
            () => this.actions.unfoldDepth(nodes, depth),
        )
    }
}
